import { useState, useEffect, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next';
import './deposits.css'
import AuthContext from 'contexte/AuthContext';
import Modal from 'components/modal/Modal';
import { RELEASE_DATE, formatDate } from 'utils/date';
import { fetchDeposits, linkToClient, fetchDepositUsers } from 'services/depositsServices';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import PageLoader from 'components/pageLoader/PageLoader';
import Notification from 'components/notifications/Notification';
import { launchSuccess, launchError } from 'components/notifications'
import { formatIBAN } from 'utils/iban';

const Deposits = () => {

  const { t } = useTranslation()
  const { user } = useContext(AuthContext)

  const [status, setStatus] = useState('ON%20HOLD')
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [fetchLimit, setFetchLimit] = useState(10)
  const [deposit, setDeposits] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalIndex, setModalIndex] = useState(0)
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });
  const [selectedUserLinked, setSelectedUserLinked] = useState({})
  const [selectedUser, setSelectedUser] = useState({});
  const [users, setUsers] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const depositData = await fetchDeposits(user, page, fetchLimit, status, selectedDate.date1.startDate, selectedDate.date1.endDate)
        setDeposits(depositData)
        setLoading(false)
      } catch (e) {
        console.error(e)
      }
    }

    if (selectedDate.date1.startDate !== null && selectedDate.date1.endDate !== null) {
      fetchData()
    }
  }, [user, fetchLimit, status, page, selectedDate])

  const resetFilter = () => {
    setFetchLimit(10)
    setSelectedDate({
      date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
      date2: { startDate: null, endDate: null },
    })
  }

  const onClickFunction = (index) => {
    setModalIndex(index)
    setIsModalOpen(true);
  }

  const transformDataToTbody = (data) => {
    if (data.length > 0) {
      return data?.map((item) => {
        return {
          data: [
            item.account_holder_name,
            formatIBAN(item.account_identifier?.iban),
            item.transaction[0].amount + ' ' + item.transaction[0].currency,
            formatDate({ date: item.createdAt, time: true })
          ]
        }
      })
    } else {
      return []
    }
  }

  const closeAndInitModalAndLister = (modalIndex) => {
    setDeposits((prevState) => {
      const newState = [...prevState]
      newState.splice(modalIndex, 1)
      return newState
    });
    setSelectedUser({});
    setSelectedUserLinked({});
    setModalIndex(-1);
    setIsModalOpen(false);
    setUsers([])
  }

  const linkMatchingUser = async () => {
    try {
      const userToLink = selectedUser?.uuid ? selectedUser : selectedUserLinked;
      if (!userToLink?.uuid) {
        return launchError(t('notifications.ago.deposits.link.no_user_selected'))
      }
      await linkToClient(user, deposit[modalIndex]._id, userToLink.uuid)
      closeAndInitModalAndLister(modalIndex);
      launchSuccess(t('notifications.ago.deposits.link.success'))
    } catch (e) {
      launchError(t('notifications.ago.deposits.link.error'))
    }
  }

  const handleSearch = async (search) => {
    if (search.length > 0) {
      try {
        const fetchUsers = await fetchDepositUsers(user, search)
        setUsers(fetchUsers)
        setLoading(false)
      } catch (e) {
        console.error(e)
      }
    } else {
      setUsers([])
    }
  }

  return (
    <DashboardLayout page={t("pages_name.deposit")}>
      <div>
        {!loading ? (
          <div>
            <Notification />
            <div className='deposit_titleComponent'>
              <h2>{t("pages.deposit.title")}</h2>
              <div className='deposit_statusFilters'>
                <div onClick={() => { setStatus('ON%20HOLD') }} className={`${status === "ON%20HOLD" && "deposit_statusSelected"} deposit_statusBox`}>{t("pages.deposit.waiting")}</div>
                <div onClick={() => { setStatus('SUCCESS') }} className={`${status === "SUCCESS" && "deposit_statusSelected"} deposit_statusBox`}>{t("pages.deposit.sucess")}</div>
              </div>
              <FilterComponent
                resetFilter={resetFilter}
                limit={true}
                date={true}
                fetchLimit={fetchLimit}
                setFetchLimit={setFetchLimit}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            </div>


            <div className="table-container">
              <div className="table-column">
                <Tableau
                  thead={[t("pages.deposit.name"), t("pages.deposit.iban"), t("pages.deposit.amount"), t("pages.deposit.date")]}
                  tbody={transformDataToTbody(deposit)}
                  hadModal={true}
                  onClickFunction={onClickFunction}
                  page={page}
                  setPage={setPage}
                  pagination={true}
                  limit={fetchLimit}
                />
              </div>
            </div>

            {
              (isModalOpen && status === "ON%20HOLD" && (
                <ModalPending isModalOpen={isModalOpen}
                  linkMatchingUser={linkMatchingUser}
                  setSelectedUserLinked={setSelectedUserLinked}
                  selectedUserLinked={selectedUserLinked}
                  onClose={() => setIsModalOpen(false)}
                  closeButton={false}
                  deposit={deposit}
                  modalIndex={modalIndex}
                  handleSearch={handleSearch}
                  users={users}
                  selectedUser={selectedUser}
                  setSelectedUser={setSelectedUser} />
              )) || (isModalOpen && status === "SUCCESS" && (
                <ModalSuccess isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)} closeButton={false} deposit={deposit} modalIndex={modalIndex} />
              ))
            }
          </div>
        ) : (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        )}
      </div>
    </DashboardLayout>
  )
}


export default Deposits

// MODALES

const ModalPending = ({ isModalOpen, linkMatchingUser, setSelectedUserLinked, selectedUserLinked, onClose, deposit, modalIndex, handleSearch, users, setSelectedUser, selectedUser }) => {

  const { t } = useTranslation()

  const handleSelectUserLinked = (user) => {
    setSelectedUserLinked(prevState => prevState.uuid === user.uuid ? {} : user);
    handleSearch('')
    setSelectedUser({})
  }

  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton={false} >
      <h2 className='modal_title'>{t("pages.deposit.pendingModal.title")}</h2>
      <div className="payout-details">
        <p><strong>{t("pages.deposit.pendingModal.name")}:</strong> {deposit[modalIndex].account_holder_name}</p>
        <p><strong>{t("pages.deposit.pendingModal.reference")}:</strong> {deposit[modalIndex].reference}</p>
        <p><strong>{t("pages.deposit.pendingModal.date")}:</strong> {formatDate({ date: deposit[modalIndex].createdAt, time: true })}</p>
        <p><strong>{t("pages.deposit.pendingModal.iban")}:</strong> {formatIBAN(deposit[modalIndex]?.account_identifier?.iban)}</p>
        <p><strong>{t("pages.deposit.pendingModal.amount")}:</strong> {deposit[modalIndex].transaction[0].amount + ' ' + deposit[modalIndex].transaction[0].currency}</p>
        <p><strong>{t("pages.deposit.pendingModal.updated_at")}:</strong> {formatDate({ date: deposit[modalIndex].updatedAt, time: true })}</p>
      </div>
      <hr className='modal_hr_button' />
      <div className='external_deposits_matching_users_box'>
        {deposit[modalIndex].matching_users.length > 0 && (
          <ul>
            {deposit[modalIndex].matching_users.map((item, index) => {
              return (
                <li key={index} onClick={() => handleSelectUserLinked(item)}
                  className={`${selectedUserLinked.uuid === item.uuid ? "linkedUserSelect" : "linkedUserNotSelect"}`}>
                  <div className='item_selectMatchingUser'>
                    <p>{item.firstName + " " + item.lastName}</p>
                    <p>{item.email}</p>
                    <p></p>
                  </div>
                </li>
              )
            })}
          </ul>
        )}
      </div>
      <UserSearchModal setSelectedUser={setSelectedUser} selectedUser={selectedUser} users={users} handleSearch={handleSearch} setSelectedUserLinked={setSelectedUserLinked} selectedUserLinked={selectedUserLinked} />
      <div className='modal-button-div'>
        <button className='close' onClick={onClose}>{t("pages.deposit.pendingModal.close")}</button>
        <button
          className='valider'
          onClick={linkMatchingUser}
          disabled={!selectedUser?.uuid && !selectedUserLinked.uuid}
        >{t("pages.deposit.pendingModal.linked")}</button>

      </div>
    </Modal>
  )
}

const ModalSuccess = ({ isModalOpen, onClose, deposit, modalIndex }) => {

  const { t } = useTranslation()

  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton={false} >
      <h2 className='modal_title'>Détail du payout</h2>
      <div className="payout-details">
        <p><strong>{t("pages.deposit.pendingModal.name")}:</strong> {deposit[modalIndex].account_holder_name}</p>
        <p><strong>{t("pages.deposit.pendingModal.reference")}:</strong> {deposit[modalIndex].reference}</p>
        <p><strong>{t("pages.deposit.pendingModal.date")}:</strong> {formatDate({ date: deposit[modalIndex].createdAt, time: true })}</p>
        <p><strong>{t("pages.deposit.pendingModal.iban")}:</strong> {deposit[modalIndex]?.account_identifier?.iban}</p>
        <p><strong>{t("pages.deposit.pendingModal.amount")}:</strong> {deposit[modalIndex].transaction[0].amount + ' ' + deposit[modalIndex].transaction[0].currency}</p>
        <p><strong>{t("pages.deposit.pendingModal.updated_at")}:</strong> {formatDate({ date: deposit[modalIndex].updatedAt, time: true })}</p>
        <p><strong>{t("pages.deposit.pendingModal.benefinary")}:</strong> {deposit[modalIndex]?.linked_user?.firstName + " " + deposit[modalIndex]?.linked_user?.lastName}</p>
      </div>
      <hr className='modal_hr_button' />
      <div className='modal_input_container'>
        <div className='modal-button-div'>
          <button className='close' onClick={onClose}>{t("pages.deposit.pendingModal.close")}</button>
        </div>
      </div>
    </Modal>
  )
}

const UserSearchModal = ({ setSelectedUser, selectedUser, users, handleSearch, setSelectedUserLinked }) => {


  const updateSearch = (searchText) => {
    handleSearch(searchText);
  };

  const selectUser = (user) => {
    setSelectedUserLinked({});
    setSelectedUser(user);
  };


  const clearSelection = () => {
    setSelectedUserLinked({});
    setSelectedUser({});
    updateSearch('')
  };

  return (
    <div className='modal_input_container'>
      {Object.keys(selectedUser).length === 0 ? (
        <input
          type="text"
          placeholder='Entrer un email'
          className='input_sleectedUser'
          onChange={(e) => updateSearch(e.target.value)}
        >

        </input>
      ) : (
        <div className={`${selectedUser?.uuid ? "linkedUserSelect" : "linkedUserNotSelect"} relative`}>
          <span onClick={() => selectUser(selectedUser)}>
            <p>{selectedUser.firstName} {selectedUser.lastName}</p>
            <p>({selectedUser.email})</p>
          </span>
          <div onClick={() => clearSelection()} className='delete_item_select'>x</div>
        </div>
      )}
      {Object.keys(selectedUser).length === 0 && users.length > 0 && (
        <ul className='users_list_box'>
          {users.map((user, index) => (
            <li key={index} onClick={() => selectUser(user)} className="linkedUserNotSelect">
              <div className='item_selectMatchingUser'>
                <p>{user.firstName + " " + user.lastName}</p>
                <p>{user.email}</p>
                <p></p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};